import {Breadcrumbs, Link, LinkProps, styled, Typography} from "@mui/material";
import {grey} from "@mui/material/colors";
import {Link as RouterLink} from "react-router-dom";

export interface BreadcrumbsListItem {
    text: string,
    href: string
}

interface BreadcrumbsListProps {
    links: BreadcrumbsListItem[];
    lastItem: Omit<BreadcrumbsListItem, 'href'>;
}


const StyledLink = styled(Link)<LinkProps>(({_}) => ({
    color: grey[600],
    textDecoration: "none",
    '&:hover': {
        textDecoration: `underline`
    }
}));

const BreadcrumbsList = ({links, lastItem}: BreadcrumbsListProps) => {
    return (
            <Breadcrumbs aria-label="breadcrumb">
                {
                    links.map((item, index) => (
                            <StyledLink key={index} to={item.href} component={RouterLink}>
                                {item.text}
                            </StyledLink>
                    ))
                }
                <Typography sx={{color: "black"}}>{lastItem.text}</Typography>
            </Breadcrumbs>
    )
}

export default BreadcrumbsList;